import * as React from 'react';
import { Pressable, Image, ScrollView, StyleSheet, View, useWindowDimensions } from 'react-native';
import { RadioButton, Text } from 'react-native-paper';
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { useNavigation } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../components/CustomButton';

const styles = StyleSheet.create({
  image: {
    width: 24,
    height: 24,
    marginRight: 10,
  },
  modal: {
    alignSelf: "center",
    backgroundColor: "white",
    padding: 20,
    borderRadius: 2,
    shadowColor: "rgba(0, 0, 0, 0.3)",
    shadowOffset: {width: 1, height: 1},
  },
  introParagraph: {
    paddingVertical: 10
  },
  buttonWrapper: {
    flexDirection: "row",
    alignSelf: "center",
    gap: 5,
    paddingTop: 10,
  },
  radioItemRow: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 5,
  },
  txt: {
    flexShrink: 1,
  },
});

export function ChangeFilter({ closePopup }) {
  const { width, height } = useWindowDimensions();
  const [selectionIndex, setSelectionIndex] = React.useState("1");
  const navigation = useNavigation();
  const dataFilter = useSelector((state) => state.dataFilter);
  const globalDispatch = useDispatch();

  React.useEffect(() => {
    if (dataFilter) {
      if (dataFilter[AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectionIndex("1");
      } else if (dataFilter[AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectionIndex("0");
      } else if (dataFilter[AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectionIndex("2");
      }
    }
  }, [dataFilter]);

  return (
    <View style={{ maxHeight: height - 50, marginTop: 50 }}>
      <ScrollView style={[styles.modal, { maxWidth: width - 50 }]}>
        <Text variant="headlineMedium">Change Filter</Text>
        <RadioButton.Group
          value={selectionIndex}
          onValueChange={setSelectionIndex}
        >
          <View style={styles.radioItemRow}>
            <RadioButton value="0" />
            <Pressable onPress={() => setSelectionIndex("0")}><Image source={require('../../assets/sunpasture.png')} style={styles.image} /></Pressable>
            <Text onPress={() => setSelectionIndex("0")} style={styles.txt}>Pasture: Only animals raised on pasture</Text>
          </View>
          <View style={styles.radioItemRow}>
            <RadioButton value="1" />
            <Pressable onPress={() => setSelectionIndex("1")}><Image source={require('../../assets/sun.png')} style={styles.image} /></Pressable>
            <Text onPress={() => setSelectionIndex("1")} style={styles.txt}>Outdoors+: Animals raised in industrial environments with outdoor access, or Pasture</Text>
          </View>
          <View style={styles.radioItemRow}>
            <RadioButton value="2" />
            <Pressable onPress={() => setSelectionIndex("2")}><Image source={require('../../assets/factory.png')} style={styles.image} /></Pressable>
            <Text onPress={() => setSelectionIndex("2")} style={styles.txt}>Indoors+: No outdoor access but meaningfully more humane than traditional industrial environments, or Outdoors+, or Pasture</Text>
          </View>
        </RadioButton.Group>
        <View style={styles.buttonWrapper}>
          <CustomButton onPress={async () => {
            closePopup();
            AppState.changeCertificationGroup(
              dataFilter,
              selectionIndex == "0" ?
                  AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY]
                :
                  (
                    selectionIndex == "1" ?
                        AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY]
                      :
                        AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY]
                  ),
              globalDispatch,
            );
          }}>Apply</CustomButton>
          <CustomButton onPress={() => {
            closePopup();
            navigation.navigate(AppConstants.SCREENS.FILTER);
          }}>Learn More</CustomButton>
          {/*<CustomButton onPress={closePopup}>Cancel</CustomButton>*/}
        </View>
      </ScrollView>
    </View>
  );
}
